interface Params {
  elem: Element;
  offset?: number;
}

export function isInViewport({ elem, offset = 0 }: Params) {
  if (!elem) return false;

  const box = elem.getBoundingClientRect();
  const { top, bottom } = box;
  const height = document.documentElement.clientHeight;

  return Math.min(height, bottom) - Math.max(offset, top) >= 0;
}

export default null;
